// client/src/components/marketer/project/modals/ServiceTypeModal.js
import React, { useState } from 'react';
import { API_URL, TYPES } from '../constants';
import '../../../../styles/marketer/modals/ServiceTypeModal.css';

export default function ServiceTypeModal({ open, onClose, projectId, onAfterChange }) {
  const [saving, setSaving] = useState(false);
  const [selected, setSelected] = useState('');

  if (!open) return null;

  const save = async () => {
    if (!selected) return;
    setSaving(true);
    try {
      if (!projectId) {
        const res = await fetch(`${API_URL}/api/marketer/mybiz/projects`, {
          method: 'POST', credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ serviceType: selected })
        });
        const j = await res.json().catch(()=>({}));
        if (!res.ok || !j?.ok) throw new Error(j?.message || '프로젝트 생성 실패');
        onAfterChange({ projectId: j.projectId, serviceType: selected, resetAll: true });
      } else {
        const res = await fetch(`${API_URL}/api/marketer/mybiz/projects/${encodeURIComponent(projectId)}/service`, {
          method: 'PATCH', credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ serviceType: selected })
        });
        const j = await res.json().catch(()=>({}));
        if (!res.ok || !j?.ok) throw new Error(j?.message || '서비스 방식 변경 실패');
        onAfterChange({ serviceType: selected, resetAll: true });
      }
      onClose();
    } catch (e) { alert(e.message || '저장 실패'); }
    setSaving(false);
  };

  return (
    <div className="service-type-modal mbm-overlay">
      <div className="service-type-modal__content mbm">
        <button onClick={onClose} aria-label="close" className="service-type-modal__close mbm-close">×</button>
        <div className="service-type-modal__header">
          <div className="service-type-modal__title mbm-title">광고 프로젝트 진행 방식을 선택해주세요</div>
        </div>
        <div className="service-type-modal__grid">
          {TYPES.map(t => (
            <div 
              key={t.key} 
              className={`service-type-modal__option ${selected === t.key ? 'service-type-modal__option--selected' : ''}`}
              onClick={() => setSelected(t.key)}
            >
              <div className="service-type-modal__option-header">
                <div className="service-type-modal__option-icon">{t.icon}</div>
                <div className="service-type-modal__option-content">
                  <div className="service-type-modal__option-label">{t.label}</div>
                  <div className="service-type-modal__option-desc">{t.description}</div>
                </div>
                {selected === t.key && (
                  <div className="service-type-modal__option-check">✓</div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="service-type-modal__actions mbm-foot">
          <button type="button" onClick={onClose} disabled={saving} className="service-type-modal__button service-type-modal__button--cancel mb-btn mb-btn-secondary">취소</button>
          <button type="button" onClick={save} disabled={saving || !selected} className="service-type-modal__button service-type-modal__button--submit mb-btn mb-btn-primary">
            {saving ? '저장 중...' : '확인'}
          </button>
        </div>
      </div>
    </div>
  );
}